//@ts-nocheck
import { useLocation, useNavigate } from 'react-router-dom';
import {
  AGENT_SETUP_ROUTE,
  SIGNUP_ROUTES,
  WABA_SETUP_ROUTES,
} from '../navigation';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  useAppSelector,
  getUserData,
  getWorkspaceId,
  useEmbeddedSignupCallbackMutation,
  useLazyGenerateEmbeddedSignupLinkQuery,
  finService,
  TrackEventType,
} from '@zonofi/seller-rtk-store';
import {
  updateAgentFlowProgress,
  updateOptedInstatus,
} from '../gandalf-firebase-controller';
import { endsWith } from 'lodash';

export const useWabaSetupScreen = () => {
  const facebookSDKLoadedRef = useRef(false);
  const sellerWorkspaceId = useAppSelector(getWorkspaceId);
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const userData = useAppSelector(getUserData);
  const [mobileNumber, setMobileNumber] = useState(userData?.mobile || '');
  const [isSuccess, setIsSuccess] = useState(false);
  const [esLinkId, setEsLinkId] = useState<string>('');
  const [embeddedSignupCallback, embeddedSignupCallbackResponse] =
    useEmbeddedSignupCallbackMutation();
  const [generateEmbeddedSignupLinkReq, generateEmbeddedSignupLinkRes] =
    useLazyGenerateEmbeddedSignupLinkQuery();

  const stepFromPath = useMemo(() => path.split('/').pop(), [path]);

  const wabaData = useMemo(
    () => ({
      phoneNumber: mobileNumber,
      displayName: (userData?.firstName + ' ' + userData?.lastName).trim(),
      email: userData?.email,
    }),
    [userData]
  );

  const calculateCompletionPercentage = useCallback(() => {
    const totalSteps = 5;
    let completedSteps = 0;
    switch (stepFromPath) {
      case 'requirements':
        completedSteps = 1;
        break;
      case 'signUp':
        completedSteps = 2;
        break;
      case 'launch':
        completedSteps = 3;
        break;
      case 'success':
        completedSteps = 4;
        break;
      default:
        completedSteps = 1;
        break;
    }
    const res = Math.floor((completedSteps / totalSteps) * 100);
    if (typeof res === 'number') {
      return res;
    }
    return 0;
  }, [stepFromPath]);

  const generateSignupLink = () => {
    generateEmbeddedSignupLinkReq({ sellerWorkspaceId });
  };

  const goToWabaRequirements = () => {
    navigate(WABA_SETUP_ROUTES.WABA_REQUIREMENTS.path);
  };

  const goToWabaSignup = () => {
    navigate(WABA_SETUP_ROUTES.WABA_SIGNUP.path);
  };

  const launchEmbededSignup = () => {
    navigate(WABA_SETUP_ROUTES.WABA_SUCCESS.path);
  };

  const navigateToHome = () => {
    navigate(AGENT_SETUP_ROUTE.path);
  };

  const goToWabaGenerateLink = () => {
    navigate(WABA_SETUP_ROUTES.WABA_GENERATE_LINK.path);
  };

  const goToWabaCopyShortLink = () => {
    navigate(WABA_SETUP_ROUTES.WABA_COPY_SHORT_LINK.path);
  };

  const navigateToSkipLauchPage = () => {
    updateOptedInstatus();
    finService.trackEvent(TrackEventType.SIGNUP_DEPLOYMENT_STARTED);
    navigate(WABA_SETUP_ROUTES.WABA_SKIP_LAUNCH.path);
  };

  const updateMobileNumber = (phoneNumber: string) => {
    setMobileNumber(phoneNumber);
  };

  const launchWhatsAppSignup2 = () => {
    finService.trackEvent(TrackEventType.SIGNUP_WABA_EMBEDDED_SIGNUP_STARTED);
    const redirectUrl = 'https://signup-qa.zotok.ai/facebook-redirect-handler';
    const state = JSON.stringify({
      esLinkId: esLinkId,
      sellerWorkspaceId: sellerWorkspaceId,
      returnUrl: window.location.href,
    });

    const facebookUrl = `https://www.facebook.com/dialog/oauth?client_id=603092012610009&config_id=656976636768601&response_type=code&redirect_uri=${encodeURIComponent(
      redirectUrl
    )}&state=${encodeURIComponent(state)}&extras=${encodeURIComponent(
      JSON.stringify({
        featureType: 'whatsapp_business_app_onboarding',
        sessionInfoVersion: '3',
        setup: { solutionID: '973279847657464' },
      })
    )}`;

    window.location.href = facebookUrl;
  };

  // Redirect handler page logic (create a new route/page for this)
  function handleFacebookRedirect() {
    const urlParams = new URLSearchParams(
      window.locationhandleFacebookRedirect.search
    );
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    if (error) {
      console.log('Facebook auth error:', error, errorDescription);

      // Parse state to get original data
      let stateData = {};
      try {
        stateData = JSON.parse(state);
      } catch (e) {
        console.error('Error parsing state:', e);
      }

      embeddedSignupCallback({
        event: 'CANCEL',
        esLinkID: stateData.esLinkId,
        sellerWorkspaceId: stateData.sellerWorkspaceId,
        data: {
          current_step: 'not_started',
        },
      });

      // Redirect back to success page or handle error
      window.location.href = WABA_SETUP_ROUTES.WABA_SUCCESS.path;
      return;
    }
  }

  const launchWhatsAppSignup = () => {
    console.log('test: launch function triggered');
    if (facebookSDKLoadedRef.current && typeof window.FB !== 'undefined') {
      window.fbq('trackCustom', 'WhatsAppOnboardingStart', {
        appId: '603092012610009',
        feature: 'whatsapp_embedded_signup',
      });
      window.FB.login(
        function (response) {
          console.log(response, 'response ===========>');

          if (response.authResponse) {
            console.log(response, 'response');
          } else {
            embeddedSignupCallback({
              event: 'CANCEL',
              esLinkID: esLinkId,
              sellerWorkspaceId: sellerWorkspaceId,
              data: {
                current_step: 'not_started',
              },
            });
            navigate(WABA_SETUP_ROUTES.WABA_FAILURE.path);
            // trackEventAPI({
            //   eventType: TrackEventType.SIGNUP_WABA_SETUP_COMPLETE,
            // });

            console.log('User cancelled login or did not fully authorize.');
          }
        },
        {
          config_id: '656976636768601',
          response_type: 'code',
          override_default_response_type: true,
          // display: 'iframe',

          extras: {
            featureType: 'whatsapp_business_app_onboarding', // set to 'whatsapp_business_app_onboarding'
            sessionInfoVersion: '3',
            setup: { solutionID: '973279847657464' },
          },
        }
      );
      navigate(WABA_SETUP_ROUTES.WABA_LOADER.path);
    } else {
      setTimeout(launchWhatsAppSignup, 1000);
    }
  };

  useEffect(() => {
    console.log('stepFromPath : ', stepFromPath);
  }, [stepFromPath]);

  useEffect(() => {
    // Facebook Pixel initialization
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    );
    window.fbq('init', 'your-pixel-id-goes-here');
    window.fbq('track', 'PageView');

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '603092012610009',
        cookie: true,
        xfbml: true,
        version: 'v19.0',
      });

      facebookSDKLoadedRef.current = true;
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    window.addEventListener('message', async (event) => {
      console.log('event.origin: listening all events ', event.origin);
      if (!event.origin.endsWith('facebook.com')) return;
      try {
        console.log('event.data: ', event); // remove after testing
        const data = JSON.parse(event.data);
        console.log('message event: ', data); // remove after testing

        if (data.event === 'FINISH') {
          console.log('WABA creation finished : ', data.event);
          setIsSuccess(true);
        }
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          console.log('message event: ', data); // remove after testing
          let payload = {
            sellerWorkspaceId: sellerWorkspaceId,
            event: data.event,
            esLinkID: esLinkId,
            data: {},
          };
          if (data.event === 'START') {
          } else if (data.event === 'CANCEL') {
            payload.data.current_step = data.data.current_step;
            navigate(WABA_SETUP_ROUTES.WABA_FAILURE.path);
          } else if (data.event === 'ERROR') {
            navigate(WABA_SETUP_ROUTES.WABA_FAILURE.path);
            payload.data.error_message = data.data.error_message;
          } else if (
            data.event === 'FINISH' ||
            data.event === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING'
          ) {
            navigate(WABA_SETUP_ROUTES.WABA_SUCCESS.path);
            updateAgentFlowProgress(3);
            if (data.data) {
              payload.data.phone_number_id = data.data.phone_number_id;
              payload.data.waba_id = data.data.waba_id;
            }
          }
          // your code goes here
          embeddedSignupCallback(payload);
        }
      } catch {
        console.log('message event: ', event.data); // remove after testing
        // your code goes here
      }
    });

    return () => {
      // Clean up the event listener on component unmount
      window.removeEventListener('message', () => {});
    };
  }, []);

  useEffect(() => {
    if (generateEmbeddedSignupLinkRes?.isSuccess) {
      setEsLinkId(generateEmbeddedSignupLinkRes?.data?.esLinkID);
      navigate(WABA_SETUP_ROUTES.WABA_LAUNCH.path);
    }
  }, [generateEmbeddedSignupLinkRes]);

  useEffect(() => {
    if (userData?.mobile) {
      setMobileNumber(userData?.mobile);
    }
  }, [userData]);

  useEffect(() => {
    console.log('esLinkId: ', esLinkId);
  }, [esLinkId]);

  return {
    calculateCompletionPercentage,
    generateSignupLink,
    goToWabaRequirements,
    goToWabaSignup,
    isWabaSigningUp:
      generateEmbeddedSignupLinkRes?.isLoading ||
      generateEmbeddedSignupLinkRes?.isFetching,
    launchEmbededSignup,
    launchWhatsAppSignup,
    mobileNumber,
    navigateToHome,
    stepFromPath,
    updateMobileNumber,
    wabaData,
    goToWabaGenerateLink,
    goToWabaCopyShortLink,
    navigateToSkipLauchPage,
  };
};
